let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k8KRL")).then(() => parcelRequire('6acuf'));